import firebase from '../../../firebase/firebase';
const firestore = firebase.firestore();

function genericSnapshot (query, commitObj, onAdded, onRemoved) {
    const { commit, addCommit, removeCommit } = commitObj;
    return query
        .onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                const payment = { id: change.doc.id, ...change.doc.data() };
                if(change.type === 'added') {
                    commit(addCommit, payment);
                    if (onAdded) onAdded(payment);
                }
                if(change.type === 'modified') {
                    commit(removeCommit, payment)
                    commit(addCommit, payment)
                }
                if(change.type === 'removed') {
                    commit(removeCommit, payment)
                    if (onRemoved) onRemoved(payment);
                }
            })
        });
}

function paymentQuerySnapshot (query, commit, filters, onAdded, onRemoved) {
    if (filters) {
        if (filters.paymentTypes && filters.paymentTypes.length)
            query = query.where('type', 'in', filters.paymentTypes);
        if (filters.date && filters.date.from)
            query = query.where('date', '>=', filters.date.from);
        if (filters.date && filters.date.to)
            query = query.where('date', '<=', filters.date.to);
    }
    const commitObj = {
        commit,
        addCommit: 'addPaymentToBill',
        removeCommit: 'removePaymentInBill',
    };
    return genericSnapshot(query, commitObj, onAdded, onRemoved);
}

export default {
    async fetchPendingBillsToSend ({ state, commit, rootGetters }, { take }) {
        commit('setLoading', true);
        try {
            const companyId = rootGetters.getCompanyID;
            commit('setFetchFlag', true);
            var query = firestore.collection(`company/${companyId}/bill`)
                .where('isClosed', '==', true)
                .where('isProcessed', '==', false)
                .orderBy('closedOn', 'desc')
                .limit(take);
            if (state.lastSnapshot)
                query = query.startAfter(state.lastSnapshot);

            const pending = await query.get();
            
            commit('setPending', pending);
            commit('setFetchFlag', pending.size >= take);
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 500)
        }
    },
    async fetchBackupDocuments ({ commit, rootGetters }, { filters, }) {
        commit('setLoading', true);
        try {
            const companyId = rootGetters.getCompanyID;
            commit('setFetchFlag', true);
            var query = firestore.collection(`company/${companyId}/invoice`)
                .where('pending', '==', true)

            commit('clearBackup');
            if (filters.date && filters.date.from)
                query = query.where('backupedAt', '>=', filters.date.from);
            if (filters.date && filters.date.to)
                query = query.where('backupedAt', '<=', filters.date.to);

            const listener = query.onSnapshot(snapshot => {
                snapshot.docChanges().forEach(async change => {
                    const invoice = { id: change.doc.id, ...change.doc.data() };
                    if(change.type === 'added') {
                        commit('addPendingInvoice', invoice);
                    }
                    if(change.type === 'modified') {
                        commit('removePendingInvoice', invoice)
                        commit('addPendingInvoice', invoice)
                    }
                    if(change.type === 'removed')
                        commit('removePendingInvoice', invoice)
                });
            });
            commit('addListener', { fetchBackupDocuments: listener });
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 500)
        }
    },
    async fetchPayments ({ rootGetters, commit, dispatch }, { filters, }) {
        commit('setLoading', true);
        try {
            var query = firestore.collection('payments')
                .where('companyId', '==', rootGetters.getCompanyID)
                .where('fiscalStatus', '==', 'pending')

            commit('unregisterListeners', 'fetchPayments');
            commit('clearBills');
            const listener = paymentQuerySnapshot(query, commit, filters,
                (payment) => { //onAdded
                    // subscribe for changes in paymets that differ from pending status - Because Fb doest support two 'in' queries. So, filters would not work
                    return dispatch('fetchPaymentsOfBill', { billId: payment.billId, filters })
                }
            );
            commit('addListener', { fetchPayments: listener });
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 500)
        }
    },
    async fetchPaymentsOfBill ({ state, rootGetters, commit }, { billId }) {
        // if already fetched for billId
        if (state.sent[billId] ) // FB not support two inequity queries :/
            return;
        const listenerName = `fetchPaymentsOfBill${billId}`;
        commit('setFetched', billId);
        commit('unregisterListeners', listenerName);
        var query = firestore.collection('payments')
            .where('companyId', '==', rootGetters.getCompanyID)
            .where('billId', '==', billId);

        const listener = paymentQuerySnapshot(query, commit, null, null);
        commit('addListener', { listenerName: listener });
    },
    async fetchIgnoredPayments ({ commit, rootGetters }, { filters }) {
        commit('setLoading', true);
        try {
            commit('unregisterListeners', 'fetchIgnoredPayments');
            commit('clearIgnored');
            
            var query = firestore.collection('payments')
                .where('companyId', '==', rootGetters.getCompanyID)
                .where('fiscalStatus', '==', 'ignored')
            if (filters && filters.date && filters.date.from)
                query = query.where('date', '>=', filters.date.from);
            if (filters && filters.date && filters.date.to)
                query = query.where('date', '<=', filters.date.to);

            const listener = genericSnapshot(query, { commit, addCommit: 'addToIgnored', removeCommit: 'removeIgnored', });
            commit('addListener', { fetchIgnoredPayments: listener });
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 500)
        }
    },
    async fetchSent ({ commit, rootGetters }, { filters }) {
        commit('setLoading', true);
        try {
            const companyId = rootGetters.getCompanyID;
            var query = firestore.collection(`company/${companyId}/invoice`)
                .where('pending', '==', false);

            commit('unregisterListeners', 'fetchSent');
            commit('clearSent');
            if (filters.date && filters.date.from)
                query = query.where('sentAt', '>=', filters.date.from);
            if (filters.date && filters.date.to)
                query = query.where('sentAt', '<=', filters.date.to);
            const listener = genericSnapshot(query, { commit, addCommit: 'addToSent', removeCommit: 'removeSent', });
            commit('addListener', { fetchSent: listener });
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 200)
        }
    },
    async fetchDisposed ({ commit, rootGetters }, { filters }) {
        commit('setLoading', true);
        try {
            const companyId = rootGetters.getCompanyID;
            var query = firestore.collection(`company/${companyId}/invoice`)
                .where('disposed', '==', true);

            commit('clearDisposed');
            if (filters.date && filters.date.from)
                query = query.where('disposedAt', '>=', filters.date.from);
            if (filters.date && filters.date.to)
                query = query.where('disposedAt', '<=', filters.date.to);

            commit('unregisterListeners', 'fetchDisposed');
            console.log('Created listener');
            const listener = genericSnapshot(query, { commit, addCommit: 'addToDisposed', removeCommit: 'removeDisposed', });
            commit('addListener', { fetchDisposed: listener });
        } finally {
            setTimeout(() => {
                commit('setLoading', false);
            }, 200)
        }
    }
}